class TemplateProduct extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.dataset.recentlyViewed) return

    this.setRecentlyViewed()
  }

  async setRecentlyViewed () {
    await window.BAO.Cart.updateCartAttributes({
      recently_viewed_products: `${this.dataset.recentlyViewed}`,
    })
  }
}

if (!customElements.get('template-product')) {
  customElements.define('template-product', TemplateProduct)
}
